import { bool, number, string } from "prop-types";

const file = {
  id: number,
  name: string.isRequired,
  size: number.isRequired,
  type: string.isRequired,
  url: string.isRequired,
  isPrivate: bool,
};

export default file;
